import { VITE_BACKEND_URL } from "../../api/config";
import type { SubscriptionActivityData } from "./subscriptionActivity.types";

export async function getSubscriptionActivity(
  signal?: AbortSignal,
): Promise<SubscriptionActivityData> {
  const backendUrl = VITE_BACKEND_URL?.replace(/\/+$/, "");

  if (!backendUrl) {
    throw new Error("La URL del backend no está configurada.");
  }

  const response = await fetch(
    `${backendUrl}/api/actividad-suscripciones`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      cache: "no-store",
      signal,
    },
  );

  if (!response.ok) {
    throw new Error("No se ha podido consultar la actividad.");
  }

  const data: unknown = await response.json();

  if (
    typeof data !== "object" ||
    data === null ||
    !("activeCount" in data) ||
    typeof data.activeCount !== "number" ||
    !Number.isSafeInteger(data.activeCount) ||
    data.activeCount < 0 ||
    !("latestSubscriberName" in data) ||
    !(
      typeof data.latestSubscriberName === "string" ||
      data.latestSubscriberName === null
    )
  ) {
    throw new Error("La respuesta del servidor no es válida.");
  }

  const name =
    typeof data.latestSubscriberName === "string"
      ? data.latestSubscriberName.trim()
      : "";

  // No mostrar el nombre de prueba detectado durante la validación.
  const isTestName =
    name.toLocaleLowerCase("es-ES") === "aaaaaaaaaaaa aaaaaaaaa";

  return {
    activeCount: data.activeCount,
    latestSubscriberName: name && !isTestName ? name : null,
  };
}
